import './EditPersonalInfoPopup.scss';
import EditPersonalInfoPopupProps from './EditPersonalInfoPopupProps';
import logo_background from '../../../../assets/images/logo-background.svg';

import { IoMdClose as CloseIcon } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { togglePersonalInfoPopup } from '../../../../store/actions/mainActions';
import { Fragment, useEffect, useState } from 'react';
import UsersService from '../../../../Axios/services/users.service';
import { Loader } from '../../../core/Loader/Loader';
import { useSelector } from 'react-redux';
import avatar from '../../../../assets/images/avatar.png'

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import {setMe, setToken} from '../../../../store/actions/authActions';
import authService from "../../../../Axios/services/auth.service";
import usersService from "../../../../Axios/services/users.service";
import SessionsService from "../../../../Axios/services/sessions.service";
import eventsService from "../../../../Axios/services/events.service";

const EditPersonalInfoPopup = (props: EditPersonalInfoPopupProps) => {

    const { isPopup, isNew, pulledUser, history } = props;
    const { me } = useSelector((state: any) => state.auth);

    const initialState = pulledUser ? {
        fullname: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        gender: 'male',
        birthDate: '',
        region: '',
        image: '',
        language: 'eng',
        password: '',
        rePassword: '',
        title: ""
    } : {
        fullname: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        gender: 'male',
        birthDate: '',
        region: '',
        image: '',
        language: 'eng',
        title: ""
    }

    const initialFlow = {
        isLoading: isPopup ? false : true,
        isComplete: false
    }

    const [state, setState] = useState(initialState)
    const [flow, setFlow] = useState(initialFlow);
    const [previewImage, setPreviewImage] = useState('');

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(togglePersonalInfoPopup(false))
    }

    const handleChange = (prop: any) => {
        setState({
            ...state,
            ...prop
        })
    }
    const isValid = (): boolean => {
        let valid: boolean = true;
        if (pulledUser && (state.password === "" || state.rePassword === '' || state.password !== state.rePassword)) {
            valid = false;
            if (
                state.fullname === "" ||
                state.firstName === "" ||
                state.lastName === "" ||
                state.email === "" ||
                state.phone === "" ||
                state.gender === "" ||
                state.birthDate === "" ||
                state.region === "" ||
                state.language === "" ||
                state.title === ""
            ) valid = false
        }
        return valid;
    }

    const submit = async () => {
        try {
            if (isValid()) {
                if (pulledUser && pulledUser._id) {
                    setFlow({
                        ...flow,
                        isLoading: true
                    })
                    await UsersService.invitation({ _id: pulledUser._id, ...state });
                    setFlow({ ...flow, isLoading: false, isComplete: true })
                } else if (me && me._id) {
                    setFlow({
                        ...flow,
                        isLoading: true
                    })
                    await UsersService.updateUserProfile({ _id: me._id, ...state });
                    handleClose()
                    const _me = await UsersService.me()


                    let userCommunities = [], connections = [], userClasses = [];
                    connections = await usersService.getFriendsByUserId(_me?._id);

                    if (_me?.classes && Array.isArray(_me?.classes)) {
                        if (_me?.classes?.length > 0) {
                            const userClasses = await SessionsService.getSessions(_me.classes);
                            _me.classes = userClasses.length > 0 ? userClasses : null;
                        }
                    }

                    const campus = await eventsService.getCourses(_me._id);
                    _me.campus = campus;
                    _me.userCommunities = userCommunities;
                    _me.connections = connections;
                    _me.sessions = [];
                    campus.forEach((c: any) => _me.sessions = [..._me.sessions, ...c.sessions]);
                    dispatch(setMe(_me));

                }
            }
        } catch (err) {
            setFlow({ ...flow, isLoading: false, isComplete: false })
            console.error(err)
        }
    }

    const handleLogin = async () => {
        try {
            const data = await authService.login(state.email, state.password);
            dispatch(setToken(data.access_token))
        } catch (err) {
            console.error(err);
        }
    }

    const goToSignIn = (e: any) => {
        e.preventDefault()
        handleLogin().then(() => {
                history?.push('/');
        });
    }

    useEffect(() => {
        if (pulledUser) {
            setState({
                fullname: (pulledUser?.firstName || pulledUser?.lastName) ? pulledUser.firstName + ' ' + pulledUser.lastName : "",
                firstName: pulledUser?.firstName ? pulledUser.firstName : "",
                lastName: pulledUser?.lastName ? pulledUser.lastName : "",
                email: pulledUser?.email ? pulledUser.email : "",
                phone: pulledUser?.phone ? pulledUser.phone : "",
                gender: pulledUser?.gender ? pulledUser.gender : "other",
                birthDate: pulledUser?.birthDate ? pulledUser.birthDate : "",
                region: pulledUser?.region ? pulledUser.region : "",
                image: '',
                language: pulledUser?.language ? pulledUser.language : "eng",
                password: '',
                rePassword: '',
                title: pulledUser?.title ? pulledUser.title : "",
            })
            setFlow({
                ...flow,
                isLoading: false
            })
        } else if (me) {
            setState({
                fullname: (me?.firstName || me?.lastName) ? me.firstName + ' ' + me.lastName : "",
                firstName: me?.firstName ? me.firstName : "",
                lastName: me?.lastName ? me.lastName : "",
                email: me?.email ? me.email : "",
                phone: me?.phone ? me.phone : "",
                gender: me?.gender ? me?.gender : "female",
                birthDate: me?.birthDate ? me?.birthDate : "",
                region: me?.region ? me?.region : "",
                image: "",
                language: me?.language ? me?.language : "en",
                title: me?.title ? me?.title : ""
            })
        }

    }, [pulledUser, me])

    useEffect(() => {
        if (state.image) {
            const reader = new FileReader();
            reader.onload = function (e: any) {
                setPreviewImage(e.target.result)
            };
            reader.readAsDataURL((state.image as any));
        }
    }, [
        state.image
    ])

    return (
        <div className="personal-info-popup">
            <div className="left h-100 d-flex flex-column py-4 px-3">
                <div className="row p-0 m-0">
                    <div className="col-12">
                        <h3>Personal Information</h3>
                    </div>
                </div>
                <div className={flow.isLoading || flow.isComplete ? " loading row h-100 p-0 m-0 py-3" : "row h-100 p-0 m-0 py-3"}>
                    <div className="col-12 col-md-6 d-flex flex-column justify-content-between">
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    required
                                    value={state.firstName}
                                    onChange={(e) => handleChange({ firstName: e.target.value })}
                                    id="firstname"
                                    label="First Name"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>

                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    required
                                    value={state.lastName}
                                    onChange={(e) => handleChange({ lastName: e.target.value })}
                                    id="lastname"
                                    label="Last Name"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>

                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    value={state.email}
                                    onChange={(e) => handleChange({ email: e.target.value })}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    id="email"
                                    label="Email"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    value={state.phone}
                                    onChange={(e) => handleChange({ phone: e.target.value })}
                                    id="phone"
                                    label="Phone"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <InputLabel id="gender">Gender</InputLabel>
                                <Select
                                    labelId="gender"
                                    id="gender"
                                    value={state.gender}
                                    label="Gender"
                                    onChange={(e) => handleChange({ gender: e.target.value })}
                                >
                                    <MenuItem value={"male"}>Male</MenuItem>
                                    <MenuItem value={"female"}>Female</MenuItem>
                                    <MenuItem value={"other"}>Other</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Year of birth"
                                    value={state.birthDate}
                                    onChange={(e) => handleChange({ birthDate: e })}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    value={state.region}
                                    onChange={(e) => handleChange({ region: e.target.value })}
                                    id="location"
                                    label="Location"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex flex-column justify-content-between">
                        <div className="form-group mb-3 p-0">
                            <label className="hc-image-file" htmlFor="profile_image">
                                {!previewImage ?
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-photo" width="60" height="60" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <line x1="15" y1="8" x2="15.01" y2="8"></line>
                                        <rect x="4" y="4" width="16" height="16" rx="3"></rect>
                                        <path d="M4 15l4 -4a3 5 0 0 1 3 0l5 5"></path>
                                        <path d="M14 14l1 -1a3 5 0 0 1 3 0l2 2"></path>
                                    </svg> :
                                    <img src={previewImage} alt="" className={"preview"} />
                                }
                                <input
                                    onChange={(e) => handleChange({ image: e.target.files?.item(0) })}
                                    type="file"
                                    id="profile_image"
                                    accept="image/png, image/gif, image/jpeg"
                                    multiple={false}
                                />
                            </label>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: "100%" }}>
                                <InputLabel id="language">Language</InputLabel>
                                <Select
                                    labelId="language"
                                    id="language"
                                    value={state.language}
                                    label="Language"
                                    onChange={(e) => handleChange({ language: e.target.value })}
                                >
                                    <MenuItem value={"heb"}>Hebrew</MenuItem>
                                    <MenuItem value={"eng"}>English</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        {pulledUser ? <Fragment><div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    required
                                    value={state.password}
                                    onChange={(e) => handleChange({ password: e.target.value })}
                                    id="newpassword"
                                    label="New Password"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                            <div className="form-group mb-3 p-0">
                                <FormControl sx={{ minWidth: '100%' }}>
                                    <TextField
                                        required
                                        value={state.rePassword}
                                        onChange={(e) => handleChange({ rePassword: e.target.value })}
                                        id="repassword"
                                        label="Retype Password"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </div>
                        </Fragment> : null
                        }
                        <div className="form-group mb-3 p-0">
                            <FormControl sx={{ minWidth: '100%' }}>
                                <TextField
                                    value={state.title}
                                    onChange={(e) => handleChange({ title: e.target.value })}
                                    id="title"
                                    label="Title"
                                    variant="outlined"
                                />
                            </FormControl>
                        </div>
                        <div className="form-group mb-3 p-0">
                            <input
                                type="submit"
                                onClick={() => submit()}
                                className={!isValid() ? 'hc-input blue-1 text-center notValid' : 'hc-input blue-1 text-center'}
                                value={isNew ? 'Continue' : 'Save'}
                            // disabled={!isValid()}
                            />
                        </div>
                    </div>
                </div>

                {flow.isLoading ? <div className="loaderWrapper d-flex justify-content-center align-items-center">
                    <Loader></Loader>
                </div> : null}

                {flow.isComplete ? <div className="completeWrapper">
                    <h4>
                        Update is complete, thank you!
                    </h4>
                    <div className="d-flex justify-content-center">
                        <div className=" my-4">
                            {history ? <input
                                type="submit"
                                onClick={(e) => goToSignIn(e)}
                                className={'hc-input blue-1 text-center'}
                                value={'Enter Hartman Connect'}
                            /> : null}
                        </div>
                    </div>
                </div> : null}
            </div>
            {isPopup && me ? <div className="right">
                <CloseIcon className="close-icon" onClick={handleClose} />
                <img className="user-photo" src={me?.image ? me?.image : avatar} alt="user" />
                <div className="user-name">{me?.firstName + ' ' + me?.lastName}</div>
                <div className="user-title">{me?.title}</div>
                <img className="logo-background" src={logo_background} alt="logo-backround" />
            </div> : null}
        </div>
    )
}

export default EditPersonalInfoPopup;